import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import useConfig from "./hooks/useConfig";
import { MsalProvider } from "@azure/msal-react";
import LoadingApp from "./pages/public/loadingApplication/LoadingApp";

export const MyAuthProvider = (props: any) => {
  const [config] = useConfig();

  if (!config?.clientId) return (
    <>
      <LoadingApp />
    </>
  )

  // MSAL configuration
  /**
   * Configuration object to be passed to MSAL instance on creation.
   * For a full list of MSAL.js configuration parameters, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
   */
  const configuration: Configuration = {
    auth: {
      clientId: config.clientId,
      authority: config.authority,
      redirectUri: config.identityRedirect
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    // uncomment logger options below when debugging authentication
    // system: {
    //   loggerOptions: {
    //     loggerCallback: (level: any, message: any, containsPii: any) => {
    //       if (containsPii) {
    //         return;
    //       }
    //       switch (level) {
    //         case LogLevel.Error:
    //           console.error(message);
    //           return;
    //         case LogLevel.Info:
    //           console.info(message);
    //           return;
    //         case LogLevel.Verbose:
    //           console.debug(message);
    //           return;
    //         case LogLevel.Warning:
    //           console.warn(message);
    //           return;
    //         default:
    //           return;
    //       }
    //     },
    //   },
    // },
  };

  const pca = new PublicClientApplication(configuration);

  return (
    <MsalProvider instance={pca}>
      {props.children}
    </MsalProvider>
  );
};